module.exports = __webpack_public_path__ + "build/img/slimes_all.3a38e1ea.png";